/**
 * Avatar — round profile image / initials fallback.
 *
 * Usage:
 *   <Avatar name="Ghaith Audi" />
 *   <Avatar src={user.avatar} name={user.name} size="lg" />
 */

const SIZES = {
  xs: 'w-6 h-6 text-[10px]',
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-12 h-12 text-base',
  xl: 'w-16 h-16 text-lg',
}

function initial(text) {
  if (!text) return 'U'
  const parts = String(text).trim().split(/\s+/)
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase()
  return parts[0].slice(0, 2).toUpperCase()
}

export default function Avatar({ src, name, size = 'md', className = '', ...rest }) {
  const base = `inline-flex items-center justify-center rounded-full overflow-hidden flex-shrink-0 ${SIZES[size] || SIZES.md} ${className}`

  if (src) {
    return (
      <span className={`${base} bg-muted`} {...rest}>
        <img
          src={src}
          alt={name || 'Avatar'}
          className="w-full h-full object-cover"
          onError={(e) => { e.target.style.display = 'none' }}
        />
      </span>
    )
  }

  return (
    <span
      className={`${base} bg-brand-soft text-brand font-semibold`}
      aria-label={name || 'Avatar'}
      {...rest}
    >
      {initial(name)}
    </span>
  )
}
